import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { PHONE_COLLECTION } = STEP_IDENTIFIER_NAME;

export const phoneCollection: StepConfig = {
	name: PHONE_COLLECTION,
	isAuthenticationRequired: true,
	isEnabled: (featureConfigs) => featureConfigs.starterSapPhoneCollection !== 'off',
};
